import { VStack, Heading, Text } from '@chakra-ui/react'
import ProfileImage from '../components/Home/ProfileImage'
import Socials from '../components/Home/Socials'
// import Typing from "../components/Home/Typing"
import Footer from '../components/Footer'
import Loader from '../components/Loader/Loader'
import { useEffect, useContext } from 'react'
import loaderContext from '../context/loaderContext'
import SEOHead from '../components/SEOHead'
import { motion, AnimatePresence } from 'framer-motion'
import Typing from '../components/Home/Typing'
import AvailabilityStatus from '../components/Home/AvailabilityStatus'
import { pageVariants, itemVariants } from '../config/animations'

const MotionVStack = motion(VStack)

function App() {
	const context = useContext(loaderContext)
	const { loading, setLoading } = context
	useEffect(() => {
		setTimeout(() => {
			setLoading(false)
		}, 1500)
	}, [setLoading])

	return (
		<VStack h="100vh" spacing={0}>
			<SEOHead
				title="Prasoon Soni | Software Engineer & Full Stack Developer"
				description="Portfolio of Prasoon Soni - A passionate software engineer and full stack developer dedicated to solving problems and making a difference through technology."
				path="/"
			/>
			<AnimatePresence>
				{loading ? (
					<Loader key="loader" />
				) : (
					<MotionVStack
						key="content"
						variants={pageVariants}
						initial="hidden"
						animate="visible"
						exit="exit"
						m={0}
						h="100vh"
						w="100%"
						spacing={0}>
						<VStack h="full" w="100%" display="flex" alignItems="center" justifyContent="center">
							<MotionVStack
								variants={itemVariants}
								display="flex"
								justifyContent="center"
								alignItems="center"
								p={4}
								borderRadius={10}>
								<ProfileImage />
								<Heading>Prasoon Soni</Heading>
								{/* <Text fontSize="xl" fontWeight="light"><TextAnimation /></Text> */}
								<Text fontSize="xl" fontWeight="medium">
									{/* <Typing /> */}
									Software Engineer
								</Text>
								<AvailabilityStatus />
								<Socials />
							</MotionVStack>
						</VStack>
						<Footer />
					</MotionVStack>
				)}
			</AnimatePresence>
		</VStack>
	)
}

export default App
